<template>
  <!-- sidebar -->
  <div class="shadow" id="sidebar-wrapper">
    <nav class="nav_sidebar">
      <div>
        <div class="nav_list">
          <router-link  id="checkBettorsLink" @click="checkAggReset()" to="/"  v-if="can('check-bettors-list')">
            <span
              class="nav_link"
              :class="{ active_sidebar: $route.name == 'checkAggregate' }"
            >
              <i class="fa fa-users" aria-hidden="true"></i>
              <span class="nav_name">
                {{ config?.sideBarNavName || 'Check Bettors' }}
              </span>
            </span>
          </router-link>

          <router-link
            to="/activity"
            class="nav_link"
            id="flaggedIncidentsLink"
            :class="{ active_sidebar: $route.name == 'activity' }"
            v-if="can('acitivity-list')"
          >
            <i class="fa fa-file-text" aria-hidden="true"></i>
            <span class="nav_name">Alerts
              <span v-if="notifications > 0" class="badge bg-danger ms-1 lh-sm">
              {{ notifications }}
            </span>
            </span>
          </router-link>
          <router-link
            to="/setting"
            class="nav_link"
            id="settingsLink"
            :class="{ active_sidebar: $route.name == 'setting' }"
            v-if="can('settings')"
          >
            <i class="fa fa-cog" aria-hidden="true"></i>
            <span class="nav_name">Settings</span>
          </router-link>
          <a @click="logout" id="signOutLink" class="nav_link">
            <i class="fa fa-sign-out" aria-hidden="true"></i>
            <span class="nav_name">Sign Out</span>
          </a>
        </div>
      </div>
      <div>

      <div id="timeZone" class="text-white">

        <!-- Default dropup button -->
<div class="btn-group dropup align-text-bottom">
  <a type="button" class="text-white dropdown-toggle me-1 timeZoneToggle" data-bs-toggle="dropdown" aria-expanded="false">
    Timezone: <span id="timeZoneUser" class="fw-bold text-muted position-relative timeZoneCaret">{{timeZoneUser}}</span>
  </a>
  <ul class="dropdown-menu">
                <li><a :class="{ 'active-timezone': selectedTimezone === 'US/Eastern' }" class="dropdown-item mb-0 fw-bolder txt_siteBlue" @click="changeTimeZone('US/Eastern')" href="#">US/Eastern</a></li>
                <li><a :class="{ 'active-timezone': selectedTimezone === 'US/Central' }" class="dropdown-item mb-0 fw-bolder txt_siteBlue" @click="changeTimeZone('US/Central')" href="#">US/Central</a></li>
                <li><a :class="{ 'active-timezone': selectedTimezone === 'US/Mountain' }" class="dropdown-item mb-0 fw-bolder txt_siteBlue" @click="changeTimeZone('US/Mountain')" href="#">US/Mountain</a></li>
                <li><a :class="{ 'active-timezone': selectedTimezone === 'US/Pacific' }" class="dropdown-item mb-0 fw-bolder txt_siteBlue" @click="changeTimeZone('US/Pacific')" href="#">US/Pacific</a></li>
              </ul>
</div>

      </div>
      <div id="buildVersion" class="text-white">Version: <span class="fw-bold text-muted">{{buildVersion}}</span> </div>
      <div id="environment" class="text-white">Environment: <span class="fw-bold text-muted">{{environment}}</span> </div>
      <div class="privacyTerms mb-2">
        <button  data-bs-toggle="modal"
                    data-bs-target="#openPrivacyModal" type="button" id="termsButton" class="p-0 text-white btnFocusOff  btn link-underline-primary">Terms & Privacy</button>
      </div>
    </div>
    </nav>
  </div>
  <!-- end sidebar -->
</template>

<script setup>
import { useConfig } from '@/composables/useConfig';
import { computed, onMounted, ref } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useAuthStore } from "../../stores/auth.store";
import { useBettorStore } from "../../stores/bettor.store";
const { config } = useConfig();
const bettorStore = useBettorStore();
const authStore = useAuthStore();
const notifications = computed(() => bettorStore.$state.notifications);
const buildVersion = computed(() => authStore.$state.buildVersion);
const environment = computed(() => authStore.$state.environment);
const timeZoneUser = computed(() =>  authStore.$state.user?.timezone);
const selectedTimezone = ref(localStorage.getItem('selectedTimezone') || timeZoneUser.value);
const userRole = computed(() => authStore.$state.user?.role);
const isAdminOrSuperAdmin = userRole.value === 'admin' || userRole.value === 'superadmin';
const isReportViewer = userRole.value === 'admin' || userRole.value === 'superadmin'|| userRole.value === 'monitoring_user' || userRole.value === 'report_editor' || userRole.value === 'report_viewer';
const route = useRoute();
const router = useRouter();
function logout() {
  authStore.logout();
}

const checkAggReset = () => {
  if(route.name == "home") {
    bettorStore.resetTimeZoneAndCheckHistory();
  }
}
const changeTimeZone = (timeZone) => {
  selectedTimezone.value = timeZone;
  bettorStore.updateUserTimeZone(timeZone);
  localStorage.setItem('selectedTimezone', timeZone);
};
onMounted(() => {
  window.sidebartoggle();
  if (isReportViewer) {
    bettorStore.getNotifications();
  }
});

</script>
<style scoped>
  .active-timezone {
    background-color: #007bff; /* Replace with your desired active background color */
    color: white; /* Replace with your desired active text color */
  }
  </style>